import { defaultButtonProps } from "components/Button/constants";
import { useHorizontalOverflow } from "components/hooks/useHorizontalOverflow";
import Tooltip from "components/Tooltip/Tooltip";
import {
    InstallBundleListAction,
    PurgeBundleListAction,
    ReInstallBundleListAction,
    ReleaseBundleListAction,
    UninstallBundleListAction,
    UpdateBundleListAction,
} from "./Actions";
import { BundleToolbar } from "./interfaces";

export const BundleActionToolbar = ({
    selectedItems,
    afterButtonAction,
    buttonProps = defaultButtonProps,
    className = "actionToolbar",
    isInlineButton,
    selectedName,
}: BundleToolbar) => {
    const repositoryHasWriteKey = selectedItems.some(
        (item) => item.resourceData.repository_has_write_key
    );
    const { ref: overflowRef, isOverflowing } = useHorizontalOverflow<HTMLDivElement>([
        selectedItems.length,
        repositoryHasWriteKey,
    ]);

    return (
        <div ref={overflowRef} className={`${className}${isOverflowing ? " isClipped" : ""}`}>
            <Tooltip overlay={"Import"}>
                <InstallBundleListAction
                    resources={selectedItems}
                    afterAction={afterButtonAction}
                    buttonProps={buttonProps}
                    isInlineButton={isInlineButton}
                    selectedName={selectedName}
                />
            </Tooltip>
            <Tooltip overlay={"Reinstall"}>
                <ReInstallBundleListAction
                    resources={selectedItems}
                    afterAction={afterButtonAction}
                    buttonProps={buttonProps}
                    isInlineButton={isInlineButton}
                    selectedName={selectedName}
                />
            </Tooltip>
            <Tooltip overlay={"Update"}>
                <UpdateBundleListAction
                    resources={selectedItems}
                    afterAction={afterButtonAction}
                    buttonProps={buttonProps}
                    isInlineButton={isInlineButton}
                    selectedName={selectedName}
                />
            </Tooltip>
            <Tooltip overlay={"Uninstall"}>
                <UninstallBundleListAction
                    resources={selectedItems}
                    afterAction={afterButtonAction}
                    buttonProps={buttonProps}
                    isInlineButton={isInlineButton}
                    selectedName={selectedName}
                />
            </Tooltip>
            {repositoryHasWriteKey && (
                <Tooltip overlay={"Release"}>
                    <ReleaseBundleListAction
                        resources={selectedItems}
                        afterAction={afterButtonAction}
                        buttonProps={buttonProps}
                        isInlineButton={isInlineButton}
                        selectedName={selectedName}
                    />
                </Tooltip>
            )}
            {repositoryHasWriteKey && (
                <Tooltip overlay={"Purge from repository"}>
                    <PurgeBundleListAction
                        resources={selectedItems}
                        afterAction={afterButtonAction}
                        buttonProps={buttonProps}
                        isInlineButton={isInlineButton}
                        selectedName={selectedName}
                    />
                </Tooltip>
            )}
        </div>
    );
};
